import { getCompanyInfo } from '@api/directOffers';
import { ofType } from 'redux-observable';
import {
  GET_COMPANY_INFO_ERROR,
  GET_COMPANY_INFO_PLUS_STATUS,
  GET_COMPANY_STATUS,
  SET_COMPANY_INFO,
} from '@actions/company';
import { catchError, map, switchMap } from 'rxjs/operators';
import { fromPromise } from 'rxjs/internal-compatibility';
import { of, concat } from 'rxjs';
import { COMPANY_SYNDICATION_STATES } from '@reducers/company';
import { get } from 'lodash';

export const getCompanyInformationPlusStatus = action$ =>
  action$.pipe(
    ofType(GET_COMPANY_INFO_PLUS_STATUS),
    switchMap(action => {
      const {
        baseUrl,
        companyKey,
        apiUrl,
        authenticationToken,
      } = action.payload;
      return fromPromise(getCompanyInfo(baseUrl, companyKey)).pipe(
        switchMap(response => {
          const payload = {
            // isWhiteListed,
            name: get(response, ['data', 'name'], ''),
            logo: get(response, ['data', 'custom_logo'], ''),
            syndicationState:
              get(response, ['data', 'parade_public_loadboard_enabled']) ===
              true
                ? COMPANY_SYNDICATION_STATES.SUPPORTED
                : COMPANY_SYNDICATION_STATES.NO_SUPPORT,
            is_placeholder: get(response, ['data', 'is_placeholder']),
            overrideEmail: get(
              response,
              ['data', 'quickview_override_email'],
              '',
            ),
          };
          return concat(
            of({ type: SET_COMPANY_INFO, payload }),
            of({
              type: GET_COMPANY_STATUS,
              payload: {
                apiUrl,
                companyKey,
                authenticationToken,
              },
            }),
          );
        }),
        catchError(err => {
          return of({ type: GET_COMPANY_INFO_ERROR, payload: err });
        }),
      );
    }),
  );
